export const SITE_URL = "https://voleybolokullari.com.tr";

export const pageRoutes = {
  home: "/", courses: "/voleybol-dersleri/", videos: "/egitim-videolari/",
  "technical-cards": "/voleybol-teknik-kartlari/",
  bulletins: "/spor-okulu-egitim-bultenleri/",
  "ready365-library": "/antrenor-egitim-kutuphanesi/",
  exams: "/sinavlar/", "junior-referee": "/junior-hakem/", demo: "/demo/",
  blog: "/voleybol-blog/",
  "volleyball-ai": "/voleybol-ai/",
  "notebooklm-ai": "/online-akademi/ai-asistan/",
  chat: "/voleybol-sohbet/",
  admin: "/yonetici/",
  faq: "/sik-sorulan-sorular/",
  pricing: "/ucretler/", register: "/kayit/",
  profiles: "/giris/", about: "/hakkimizda/", contact: "/iletisim/",
  privacy: "/gizlilik-politikasi/", help: "/yardim-merkezi/",
  coaches: "/egitmenler/", live: "/canli-dersler/",
};

export const routePages = Object.fromEntries(Object.entries(pageRoutes).map(([page, route]) => [route, page]));

export const slugifyTr = (value = "") => value.toLocaleLowerCase("tr-TR").normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "").replace(/ı/g, "i").replace(/ğ/g, "g")
  .replace(/ü/g, "u").replace(/ş/g, "s").replace(/ö/g, "o").replace(/ç/g, "c")
  .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

export const routeFor = (page, course) => {
  if (page === "course" && course) return `/voleybol-dersleri/${slugifyTr(course[1])}/`;
  if (page === "lesson" && course) return `/voleybol-dersleri/${slugifyTr(course[1])}/egitim/`;
  return pageRoutes[page] || `/${slugifyTr(page)}`;
};

export const resolveRoute = (pathname, courses) => {
  const path = (pathname || "/").replace(/\/+$/, "") || "/";
  if(path === "/kayitli-spor-okullari") return {page:"register",course:null};
  if (/^\/voleybol-blog(?:\/[^/]+)?$/.test(path)) return { page: "blog", course: null };
  const lessonMatch = path.match(/^\/voleybol-dersleri\/([^/]+)\/egitim$/);
  const courseMatch = path.match(/^\/voleybol-dersleri\/([^/]+)$/);
  const match = lessonMatch || courseMatch;
  if (match) {
    const course = courses.find((item) => slugifyTr(item[1]) === match[1]);
    if (course) return { page: lessonMatch ? "lesson" : "course", course };
  }
  return { page: routePages[path] || routePages[`${path}/`] || "home", course: null };
};

const metaByPage = {
  "ready365-library": ["Antrenör Eğitim Kütüphanesi", "Spor okulları ve antrenörlere özel voleybol antrenman PDF kütüphanesi."],
  bulletins: ["Spor Okulu Eğitim Bültenleri", "Spor okullarının sporcularına yönelik haftalık eğitim bülteni yönetim alanı."],
  home: ["Online Voleybol Akademisi | Voleybol Okulları", "Voleybolcular ve spor okulları için teknik, taktik, mental hazırlık ve performans odaklı çevrim içi eğitim platformu."],
  courses: ["Voleybol Dersleri ve Eğitim Programları", "Parmak pas, manşet, servis, smaç, blok, pozisyon ve performans konularında başlangıçtan ileri seviyeye voleybol dersleri."],
  "technical-cards": ["Voleybol Teknik Kartları | A4 Eğitim Belgeleri", "Parmak pas, manşet, servis, smaç, blok ve savunma teknikleri için A4 voleybol eğitim kartlarını görüntüleyin; Word veya PDF olarak indirin."],
  videos: ["Voleybol Eğitim Videoları", "Voleybol tekniklerini hareket örnekleriyle öğrenebileceğiniz mobil uyumlu eğitim video kütüphanesi."],
  exams: ["Voleybol Sınavları ve Değerlendirmeler", "Voleybol derslerine göre hazırlanmış çoktan seçmeli sınavlarla bilgilerinizi ölçün."],
  "junior-referee": ["Junior Hakem Akademisi | Voleybol Hakemliği", "Gençler için voleybol kuralları, örnek olaylar, hakem kararları ve gözlemci görevleri eğitim alanı."],
  blog: ["Voleybol Blog | Teknik, Taktik ve Sporcu Gelişimi", "Voleybol teknikleri, taktik, pozisyon eğitimi, atletik performans, beslenme, sağlık ve mental gelişim yazıları."],
  "volleyball-ai": ["Voleybol AI Asistanı | Ücretsiz Voleybol Soru Cevap", "Yalnızca voleybol hakkında, akademinin eğitim içeriklerine dayanarak site içinde ve ücretsiz çalışan voleybol soru-cevap asistanı."],
  "notebooklm-ai": ["Voleybol AI Asistanı | Online Voleybol Akademisi", "Voleybol teknikleri, kurallar ve eğitim içerikleri hakkında AI destekli çalışma alanımızdan yararlanın."],
  chat: ["Voleybol Chat | Online Voleybol Akademisi", "Kayıtlı kullanıcılar için 24 saatlik güvenli voleybol sohbet alanı."],
  faq: ["Sık Sorulan Sorular | Online Voleybol Akademisi", "Spor okulu ve sporcu kaydı, giriş, voleybol dersleri, eğitim videoları, sınavlar ve üyelik sistemi hakkında ayrıntılı yanıtlar."],
  pricing: ["Voleybol Akademisi Üyelik Ücretleri", "Sınırsız öğrenci erişimli aylık ve yıllık üyelik seçeneklerini inceleyin."],
  register: ["Kullanıcı Kaydı", "Kullanıcı hesabınızı oluşturun; voleybol derslerine, videolara ve sınavlara tek hesabınızla ulaşın."],
  "registered-schools": ["Kayıtlı Voleybol Spor Okulları", "Online Voleybol Akademisine kayıtlı spor okullarını isimleri ve kulüp logolarıyla inceleyin."],
  profiles: ["Voleybol Akademisi Giriş", "Kullanıcı hesabınızla Online Voleybol Akademisine giriş yapın."],
  demo: ["Online Voleybol Akademisi Demo", "Ders, eğitim videosu ve sınav modüllerinin örnek kullanımını inceleyin."],
  admin: ["Yönetici Alanı | Online Voleybol Akademisi", "Voleybol Akademisi güvenli içerik yönetimi alanı."],
  privacy: ["Gizlilik ve Kişisel Verilerin Korunması | Voleybol Akademisi", "Online Voleybol Akademisi okul, sporcu ve antrenör verilerinin işlenmesi, güvenliği, saklanması ve KVKK kapsamındaki haklar hakkında ayrıntılı gizlilik politikası."],
  coaches: ["Eğitmenlerimiz | Online Voleybol Akademisi", "Online Voleybol Akademisi beden eğitimi, spor, dijital geliştirme ve içerik alanlarında görev alan eğitmen ve uzman profilleri."],
};

export function seoFor(page, course) {
  if ((page === "course" || page === "lesson") && course) return {
    title: `${course[1]} ${page === "lesson" ? "Eğitimi" : "Dersi"} | Online Voleybol Akademisi`,
    description: course[2] || `${course[1]} konusunda ayrıntılı voleybol eğitimi.`,
    path: routeFor(page, course), noindex: true,
  };
  const [title, description] = metaByPage[page] || [`${String(page).replace(/-/g, " ")} | Voleybol Akademisi`, "Online Voleybol Akademisi bilgi sayfası."];
  return { title, description, path: routeFor(page), noindex: ["profiles", "exams", "videos", "courses", "technical-cards", "bulletins", "ready365-library", "chat", "admin"].includes(page) };
}
